import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ICutOff } from '../models/cut-off.model';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { createRequestOption } from '../app/shared/util/request-util';

type EntityResponseType = HttpResponse<ICutOff>;
type EntityArrayResponseType = HttpResponse<ICutOff[]>;

@Injectable({ providedIn: 'root' })
export class BaryCutOffService implements IBaryTableFetchService<ICutOff> {
  public resourceUrl = 'api/cut-offs';

  constructor(protected http: HttpClient) {}

  fillDataToShow(entities: ICutOff[]): Observable<ICutOff[]> {
    return of(entities);
  }

  create(acceptance: ICutOff): Observable<EntityResponseType> {
    return this.http.post<ICutOff>(this.resourceUrl, acceptance, { observe: 'response' });
  }

  update(acceptance: ICutOff): Observable<EntityResponseType> {
    return this.http.put<ICutOff>(this.resourceUrl, acceptance, { observe: 'response' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ICutOff>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICutOff[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  queryAsCustomer(customerId: number, req?: any): Observable<any> {
    return this.query(req);
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }
}
